import { render, staticRenderFns } from "./authmanagem.vue?vue&type=template&id=eb778c94&scoped=true&"
import script from "./authmanagem.vue?vue&type=script&lang=js&"
export * from "./authmanagem.vue?vue&type=script&lang=js&"
import style0 from "./authmanagem.vue?vue&type=style&index=0&id=eb778c94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb778c94",
  null
  
)

export default component.exports